import React, {useState, useEffect, useContext} from 'react';
// design
import {Radio, Table} from 'antd';
// context
import {GlobalContext} from "../context/globalContext";
// method
import {getMethod} from '../services/methods';
import "react-datepicker/dist/react-datepicker.css";

export default function Dashboard() {
    const {contextData, dispatch} = useContext(GlobalContext);
    const [tableData, setTableData] = useState(null);
    const [tableType, setTableType] = React.useState(contextData.userData.role == "admin-county" ? "county" : "state");


    async function fetchTablesData() {
        const tableData = await getMethod("/dashboard/tables");
        setTableData(tableData)
    }

    useEffect(() => {
        fetchTablesData();
    }, [])

    const doing = (row) => {
        return row.engagement.length;
    }

    const done = (row) => {
        return row.engagement.filter(item => item.is_completed).length;
    }

    const percent = (row) => {
        let total = parseFloat(100 * done(row) / doing(row)).toFixed(0);
        return `% ${total == "NaN" ? 0 : total}`
    }

    const columns = [
        {
            title: 'Ad',
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Soyad',
            dataIndex: 'surname',
            key: 'surname'
        },
        {
            title: 'İl',
            dataIndex: 'state',
            key: 'state'
        },
        {
            title: 'İlçe',
            dataIndex: 'county',
            key: 'county'
        },
        {
            title: 'Planlanan Etkinlik',
            dataIndex: 'doing',
            render: (value, row, index) => {
                return doing(row);
            },
        },
        {
            title: 'Tamamlanan Etkinlik',
            dataIndex: 'done',
            render: (value, row, index) => {
                return done(row);
            },
        },
        {
            title: 'Oran',
            dataIndex: 'percent',
            render: (value, row, index) => {
                return percent(row);
                ;
            },
        }
    ];

    if (tableType == "state") {
        delete columns[3];
    }

    const onTableDataChange = e => {
        setTableType(e.target.value);
    };

    return (
        <>
            {contextData.userData.role != "admin-county" &&
                <Radio.Group style={{marginBottom: "16px"}} onChange={onTableDataChange} value={tableType}>
                    <Radio value={"state"}>İl</Radio>
                    <Radio value={"county"}>İlçe</Radio>
                </Radio.Group>
            }
            <Table
                loading={!tableData ? true : false}
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={tableType == "state" ? tableData?.tableState : tableData?.tableCounty}
                pagination={false}/>
        </>
    )
}
